import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[DateMask]',
    standalone: false,
})

export class DateDirective {
    onTouched: any;
    onChange: any;
    value: '' | undefined;
    dateType: '99/99/9999';

    @Input('dateMask') dateMask: string | undefined;

    constructor() {
        this.dateType = '99/99/9999';
    }

    @HostListener('keyup', ['$event'])
    onKeyup($event: any) {

        if ($event.target.value === undefined) {
            return null;
        }


        const value = $event.target.value.replace(/\D/g, '');

        if ($event.keyCode === 8) {
            return value;
        }

        let novoValor: string | null = $event.target.value;
        if (value.length <= 8) {
            novoValor = this.maskDate(value);
        } else if (value.length > 10) {
            novoValor = null;
        } else {
            novoValor = $event.target.value.substr(0, 10);
        }

        // Atualiza o input e dispara `input` event para que o ControlValueAccessor
        // (ex.: MatDatepickerInput / FormControl) reparse e sincronize o estado.
        if (novoValor !== $event.target.value) {
            $event.target.value = novoValor;
            $event.target.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }

    @HostListener('blur', ['$event'])
    onBlur($event: any) {

        if ($event.target.value === undefined) {
            return null;
        }

        if ($event.target.value.length === this.dateType.length) {
            return $event.target.value;
        } else if ($event.target.value.length > 10) {
            return null;
        } else {
            return $event.target.value.substr(0, 10);
        }

    }

    maskDate(value: string): string {
        value = value.replace(/\D/g, '');
        const replacement = this.dateType.replace(/\D/g, '').replace(/9/g, '_');
        const valueMask = value + replacement.substring(0, replacement.length - value.length);
        let valueMaskPos = 0;
        value = '';
        for (let i = 0; i < this.dateType.length; i++) {
            if (isNaN(parseInt(this.dateType.charAt(i), 10))) {
                value += this.dateType.charAt(i);
            } else {
                value += valueMask[valueMaskPos++];
            }
        }

        if (value.indexOf('_') > -1) {
            value = value.substr(0, value.indexOf('_'));
        }

        return value;
    }
}
